import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=4a1e81ba&scoped=true&"
import script from "./RecipeDetail.vue?vue&type=script&lang=js&"
export * from "./RecipeDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=4a1e81ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e81ba",
  null
  
)

export default component.exports